export const AlignmentNormalize = {
    left: "flex-start",
    center: "center",
    right: "flex-end",
    space_between: "space-between"
}
